import { MasterSignaling } from "../net/masterSignaling";
import { BaseController } from "./base.controller";

const $ = require('jquery');
const catlabremote = require('catlab-remote-client');
const Webcontrol = catlabremote.Webcontrol;

export class HostController extends BaseController{

    async initialize(autoOpenWindow: boolean = false) {

		await Webcontrol.initialize({
			serverlist: 'https://remote-serverlist.catlab.eu/servers.json'
		}).then(() => {

			window.onbeforeunload = function(){
				return 'Are you sure you want to leave?';
			};

			const a = $('<a target="_blank" id="connectInfo"></a>');
			a.text(Webcontrol.getConnectToken());
			a.attr('href', '?token=' + Webcontrol.getConnectToken());

			// Open
			if (autoOpenWindow) {
				window.open('?token=' + Webcontrol.getConnectToken(), 'people-remote');
			}

			$('#root').append(a);

			Webcontrol.on('user:join', (user) => {
				console.log('User joined', user);

				this.signaling = new MasterSignaling(user , this.onMessage.bind(this));
				this.signaling.send({ type: 'hello?' });

				this.initKeyboardListener(user);
				this.initGamepadListener(user);

			});

		});

    }

	protected handleRemoteTrackAdded(event: RTCTrackEvent) {
		
		if (event.track.kind === 'video') {

			event.streams.forEach((stream) => {
				const video = document.createElement('video');
				video.srcObject = stream;
				//video.autoplay = true;
				video.playsInline = true;

				try {
					video.play();
				} catch (e) {
					console.error('Error playing video:', e);
					$(document.body).on('click', () => {
						video.play();
					});
				}

				$('#root').append(video);
			});
		}

	}

	protected initKeyboardListener(user) {
	
		var pressedKeys = {};

		// Listen for these commmands: wasd for movement and arrows for viewing. Send these as events in the remote.
		$(document).on('keydown', (event) => {
			event.preventDefault();

			if (pressedKeys[event.key]) return;
			pressedKeys[event.key] = true;

			user.events.trigger('people-command:key-down', {
				key: this.mapKey(event.key),
			});
		});

		$(document).on('keyup', (event) => {
			event.preventDefault();

			if (!pressedKeys[event.key]) return;
			pressedKeys[event.key] = false;

			user.events.trigger('people-command:key-up', {
				key: this.mapKey(event.key),
			});
		});

	}

	protected initGamepadListener(user) {

		let gamepadLoopInterval = null;
		
		let looking = {
			up: false,
			down: false,
			left: false,
			right: false
		};

		let moving = {
			forward: false,
			backward: false,
			left: false,
			right: false
		}

		window.addEventListener("gamepadconnected", (e) => {
			
			if (gamepadLoopInterval) {
				clearInterval(gamepadLoopInterval);
			}

			gamepadLoopInterval = setInterval(() => {
				const gamepads = navigator.getGamepads();
				for (let i = 0; i < gamepads.length; i++) {
					const gamepad = gamepads[i];
					if (!gamepad) {
						continue;
					}

					const axes = gamepad.axes;
					const buttons = gamepad.buttons;

					const moveVertical = axes[1];
					const moveHorizontal = axes[0];

					const lookVertical = axes[3];
					const lookHorizontal = axes[2];

					// Check movement
					const actions = [
						{ axis: moveVertical, threshold: -0.5, action: 'move-forward', state: moving, key: 'forward' },
						{ axis: moveVertical, threshold: 0.5, action: 'move-backward', state: moving, key: 'backward' },
						{ axis: moveHorizontal, threshold: -0.5, action: 'move-left', state: moving, key: 'left' },
						{ axis: moveHorizontal, threshold: 0.5, action: 'move-right', state: moving, key: 'right' },
						{ axis: lookVertical, threshold: -0.5, action: 'look-up', state: looking, key: 'up' },
						{ axis: lookVertical, threshold: 0.5, action: 'look-down', state: looking, key: 'down' },
						{ axis: lookHorizontal, threshold: -0.5, action: 'look-left', state: looking, key: 'left' },
						{ axis: lookHorizontal, threshold: 0.5, action: 'look-right', state: looking, key: 'right' }
					];

					actions.forEach(({ axis, threshold, action, state, key }) => {
						if ((threshold < 0 && axis < threshold) || (threshold > 0 && axis > threshold)) {
							if (!state[key]) {
								state[key] = true;
								user.events.trigger('people-command:key-down', { key: action });
							}
						} else {
							if (state[key]) {
								state[key] = false;
								user.events.trigger('people-command:key-up', { key: action });
							}
						}
					});
				}
			}, 1000 / 60);

		});

	};

	private mapKey(key: string) {
		// Available keys:
		// look-up look-down look-left look-right
		// move-forward move-backward move-left move-right
		switch (key.toLowerCase()) {
			case 'w':
				return 'move-forward';
			case 's':
				return 'move-backward';
			case 'a':
				return 'move-left';
			case 'd':
				return 'move-right';
			case 'arrowup':
				return 'look-up';
			case 'arrowdown':
				return 'look-down';
			case 'arrowleft':
				return 'look-left';
			case 'arrowright':
				return 'look-right';
		}

		return null;
	}
}